
export default {
    login({ commit }, user) {
        commit('LOGIN', user)
    },
};
